export const environment = {
  production: true,
  env: 'Production',
  ApiUrl: 'https://gvhthapi.clavisco.com/',
  UiUrl: 'https://gvhth.clavisco.com/#/',
  KeyReportManager: 67,
  Company: 34,
  RptManager_Url: "https://rptmngapiv2.clavisco.com/"
};
